var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowRightYellow = function SvgArrowRightYellow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    "aria-hidden": "true",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.28658 11.7579H12.8158L9.88224 15.0936C9.57547 15.4139 9.57547 15.9395 9.88224 16.2598C10.189 16.5801 10.6846 16.5801 10.9913 16.2598L15.2699 11.5197C15.5767 11.1994 15.5767 10.682 15.2699 10.3617L10.9036 5.74021C10.7567 5.58642 10.5572 5.5 10.3491 5.5C10.141 5.5 9.94152 5.58642 9.79456 5.74021C9.4878 6.0605 9.4878 6.5779 9.79456 6.89819L12.8158 10.1154H5.28658C4.85396 10.1154 4.5 10.4849 4.5 10.9366C4.5 11.3883 4.85396 11.7579 5.28658 11.7579Z",
    fill: "#FFE575"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowRightYellow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrowRightYellow.098ae075.svg";
export { ForwardRef as ReactComponent };